/* src/modules/discounts/selectors.js */

import { createSelector } from 'reselect';
import { find, isEmpty, keyBy, map, uniqWith } from 'lodash';
import { getMoment } from '../../util/dates';
import { loadTexts } from '../../config/texts';

export const getDiscountHolders = createSelector(
  state => state.discounts.main.data,
  state => state.appState.locale,
  (holders, locale) => map(holders, d => {
    const texts = loadTexts('discount', locale);
    const { fields } = texts;
    const {
      _id,
      discounts,
      name,
      universities,
      // active,
      // body,
      // usedBy,
    } = d;
    return {
      _id,
      [fields.name]: name,
      [fields.institution]: (universities || []).reduce((acc, x) => (acc ? `${acc}, ${x.shortName}` : x.shortName), ''),
      [fields.number_of_discount_code]: (discounts || []).length,
      [fields.total_used]: (discounts || []).reduce((acc, x) => acc + x.usedBy.length, 0),
    };
  })
);

export const getSeasons = createSelector(
  state => state.discounts.seasons.data,
  seasons => map(seasons, ({ _id, startDate, endDate }) => ({
    _id,
    startDate: getMoment(startDate.timestamp),
    endDate: getMoment(endDate.timestamp),
  }))
);

export const getOwners = createSelector(
  state => state.discounts.main.data,
  owners => map(owners, ({ _id, name }) => ({
    _id,
    name,
  }))
);

export const getOrganization = createSelector(
  state => state.auth.data.user.organizations,
  state => state.auth.selectedOrganization,
  (organizations, selected) => {
    const org = find(organizations, o => o._id === selected);
    if (!org) return { _id: null, name: '' };
    return {
      _id: selected,
      name: org.name,
    };
  }
);

export const getSelected = createSelector(
  state => state.discounts.main.data,
  state => state.discounts.main.selected,
  state => state.auth.data.user.universities,
  state => state.appState.locale,
  (data, selected, universities, locale) => {
    const texts = loadTexts('discount', locale);
    const { fields } = texts;
    const def = {
      _id: '',
      name: 'Not Selected',
      discounts: [],
      email: '',
      phone: '',
      universities: [],
    };
    if (isEmpty(selected) || isEmpty(data[selected])) return def;
    const s = data[selected];
    return {
      _id: s._id,
      name: s.name,
      discounts: map(s.discounts, d => {
        const start = getMoment(d.season.startDate.timestamp);
        const end = getMoment(d.season.endDate.timestamp);
        return {
          _id: d._id,
          [fields.code]: d.body,
          [fields.used_count]: d.usedBy.length,
          [fields.valid_period]: `${start.format('MMM D, Y')} - ${end.format('MMM D, Y')}`,
          [fields.active]: d.active ? 'Yes' : 'No',
        };
      }),
      email: s.email || 'No Email',
      phone: s.phone || 'No Phone',
      organization: s.organization.name,
      universities: s.universities,
      universityChoices: keyBy(uniqWith([...universities, ...s.universities], (a, b) => a._id === b._id), '_id'),
    };
  }
);



// WEBPACK FOOTER //
// ./src/modules/discounts/selectors.js